import Avatar from '@ui/Avatar';
import { isEmpty, trim } from 'lodash-es';
import React, { useCallback } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import Typography from '@ui/Typography';
import mentionClasses from './tag-mention-input.module.css';
import { cx } from 'cva';

function TagMentionInput(props, inputRef) {
  const { className, onChange, style = {}, placeholder, ...rest } = props;
  const fetchHashTags = async (searchText, callback) => {
    if (isEmpty(trim(searchText))) {
      callback([]);
    } else {
      const res = await fetch(`/proxy/v1/hashtags?search=${searchText}`);
      if (res.ok) {
        const { data } = await res.json();
        if (!isEmpty(data)) {
          callback(
            data.map((hashtag) => ({
              display: `#${hashtag.tag}`,
              id: hashtag.id,
            })),
          );
        } else {
          callback([]);
        }
      }
    }
  };

  const fetchUsers = async (searchText, callback) => {
    if (isEmpty(trim(searchText))) {
      callback([]);
    } else {
      const res = await fetch(`/proxy/v1/users?search=${searchText}`);
      if (res.ok) {
        const { data } = await res.json();
        if (!isEmpty(data)) {
          callback(
            data.map((user) => ({
              ...user,
              display: `${user.first_name} ${user.last_name}`,
              id: user.id.toString(),
            })),
          );
        } else {
          callback([]);
        }
      }
    }
  };

  const renderUserSuggestion = (
    user,
    search,
    highlightedDisplay,
    index,
    focused,
  ) => {
    return (
      <div className="flex items-center justify-start gap-3">
        <Avatar src={user.avatar} alt={user.first_name} size="sm" />
        <Typography variant="body2" className={focused ? '!font-medium' : ''}>
          {user.first_name} {user.last_name}
        </Typography>
      </div>
    );
  };

  // TODO Shyam: Fix this
  const insertHashTagAdditions = (text, isOnBlur) => {
    // let processedValue = text;
    // const hashTags = processedValue.match(/#\w+\s/g) || [];
    // if (isOnBlur) {
    //   const lastWord = last(processedValue.split(' '));
    //   if (lastWord.startsWith('#') && lastWord.length > 1) {
    //     hashTags.push(lastWord);
    //   }
    // }
    // hashTags.forEach((hashTag) => {
    //   const trimmed = trim(hashTag);
    //   const hashTagMarkup = `@[${trimmed}](-1)`;
    //   if (!processedValue.includes(hashTagMarkup)) {
    //     processedValue = processedValue.replace(trimmed, hashTagMarkup);
    //   }
    // });
    // return processedValue;
    return text;
  };

  const handleValueChange = useCallback(
    (_, newValue) => {
      const processedValue = insertHashTagAdditions(newValue, false);
      onChange(processedValue);
    },
    [onChange],
  );

  const handleOnBlur = (_, clickedSugestion) => {
    if (!clickedSugestion) {
      const processedValue = insertHashTagAdditions(rest.value, true);
      if (processedValue !== rest.value) {
        onChange(processedValue);
      }
    }
  };

  return (
    <MentionsInput
      {...rest}
      onChange={handleValueChange}
      inputRef={inputRef}
      placeholder={placeholder || ''}
      onBlur={handleOnBlur}
      a11ySuggestionsListLabel="Suggested user mentions and hashtags based on typed text"
      classNames={mentionClasses}
      className={cx(className, 'mentions')}
      style={style}>
      <Mention trigger="#" data={fetchHashTags} className="mention-hashtag" />
      <Mention
        trigger="@"
        data={fetchUsers}
        className="mention-user"
        renderSuggestion={renderUserSuggestion}
      />
    </MentionsInput>
  );
}

export default React.forwardRef(TagMentionInput);
